import { useEffect } from "react";

export function useHideElement(selector: string) {
  useEffect(() => {
    const el = document.querySelector(selector) as HTMLElement | null;
    if (el) el.style.display = "none";
    return () => {
      if (el) el.style.display = "";
    };
  }, [selector]);
}
